import request from '../utils/request'

export function add(object) {
  return request.post('/order-account', object)
}

export function put(object) {
  return request.put('/order-account', object)
}

export function list(object) {
  return request.post('/order-account/list', object)
}

export function listBySell(object) {
  return request.post('/order-account/listBySell', object)
}

export function deleteById(id) {
  return request.delete('/order-account/'+id)
}


export function getOrderStatusTypeAll() {
  return request.post('/order-account/getOrderStatusTypeAll')
}

// 订单支付
export function pay(id) {
  return request.get('/order-account/pay/'+id)
}

// 取消订单 订单关闭
export function cancel(id) {
  return request.get('/order-account/cancel/'+id)
}

// 发货
export function shipments(id) {
  return request.get('/order-account/shipments/'+id)
}

// 确认收货
export function confirm(id) {
  return request.get('/order-account/confirm/'+id)
}


